module.exports = __webpack_public_path__ + "static/products-intro-596a31fc92fe27c7489fbf50101b37e1.jpg";